<app-adminav></app-adminav>
<div class="container mt-5 mb-5">
    <div class="col-lg-12">
        <h3>Crear un nuevo artículo</h3>
        <hr>
        <button class="btn btn-primary mr-2" (click)="imagen()">Agregar Imagen</button> <button (click)="videoIn()" class="btn btn-success">Agregar Video</button>
        <hr>
        <form [formGroup]="newPostForm" (ngSubmit)="addPost(newPostForm.value)">
            <div *ngIf="video == false" class="row">
                <div class="form-group col-lg-6">
                    <label for="">Imagen del artículo:</label>
                    <input type="file" class="form-control" (change)="handleImage($event)">
                </div>
                <div class="col-lg-6">
                    <img src="" alt="">
                </div>
            </div>
            <div *ngIf="video == true" class="row">
              <div class="form-group col-lg-12">
                  <label for="">Video del artículo:</label>
                  <input type="text" class="form-control" placeholder="Inserta aqui el Iframe del video" (change)="asignarVideo($event.target.value)">
              </div>

          </div>
            <div class="form-group">
                <label for="">Título:</label>
                <input type="text" class="form-control" placeholder="Ingrese el título" formControlName="titulo">
            </div>
            <div class="form-group">
                <label for="">Introducción:</label>
                <input type="text" class="form-control" placeholder="Introducción del contenido" formControlName="introduccion">
            </div>

            <div class="form-group">
                <label for="">Párrafo del artículo:</label>
                <textarea class="form-control" id="" cols="30" rows="7" formControlName="contenido" [(ngModel)]="parrafo"></textarea>
            </div>

            <div>
              <button type="button"  class="btn btn-success" (click)="nuevoParrafo()">Agregar párrafo</button>
            </div>
            <br>
            <div *ngIf="content">
              <label>Contenido del post:</label>
              <hr>
              <p style="font-size: 11px; text-align: justify;" *ngFor="let item of content">{{item}}</p>
            </div>
            <br>
            <div class="text-center">
                <button type="submit" class="btn btn-dark btn-block">Publicar Artículo</button>
            </div>
        </form>
    </div>
</div>
